document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.banner-one');
  if (!sections.length) return;

  var observer = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          entry.target.classList.add('has-been-viewed');
        } else {
          entry.target.classList.remove('is-in-view');
        }
      });
    },
    { threshold: 0.7 }
  );

  sections.forEach(function (sec) {
    observer.observe(sec);
  });
});
